<template>
    <div @click="onSearchClose()" class="messages-search">
        <form @click.stop>
            <div v-if="full_search_visible === false" class="simple-search">
                <div class="content">
                    <fieldset class="control-group">
                        <legend>{{Language.say('messages.list.search.search_for')}}</legend>

                        <ul class="control radio-buttons-group">
                            <li>
                                <input v-model="quick_search.qsearchfield" type="radio" name="searchBy" value="subject" id="subject" :checked="quick_search.qsearchfield === 'subject'" tabindex="-1">
                                <label for="subject" tabindex="0">{{Language.say('messages.list.search.subject')}}</label>
                            </li>
                            <li>
                                <input v-model="quick_search.qsearchfield" type="radio" name="searchBy" id="recip" value="recip" :checked="quick_search.qsearchfield === 'recip'" tabindex="-1">
                                <label for="recip" tabindex="0">{{Language.say('messages.list.search.participants')}}</label>
                            </li>
                            <li>
                                <input v-model="quick_search.qsearchfield" type="radio" name="searchBy" id="all" value="all" :checked="quick_search.qsearchfield === 'all'" tabindex="-1">
                                <label for="all" tabindex="0">{{Language.say('messages.list.search.all')}}</label>
                            </li>
                        </ul>
                    </fieldset>
                    <div class="search-input">
                        <div class="control-group">
                            <div class="control" role="search">
                                <input
                                  type="text" @keyup.enter="onQuickSearchSubmit()"
                                  v-model="quick_search.qsearch"
                                  :placeholder="Language.say('messages.list.search.search')"
                                  v-focus="true"
                                >
                                <ActionButton v-show="quick_search.qsearch"
                                  @click="onQuickSearchClear()"
                                  icon='fas fa-times'
                                  class="clear"
                                />
                                
                                <button @click.prevent="onQuickSearchSubmit()"
                                    type="submit"
                                    :disabled="!quick_search.qsearch"
                                >
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ActionButton @click="onFullSearchShow()" icon='fas fa-search-plus' class="outline clear" text="messages.list.search.advanced"/>
                </div>
            </div>

            <div v-else class="advanced-search">
                <div class="content">
                    <fieldset>
                        <legend>{{Language.say('messages.list.search.where')}}</legend>
                        <div class="select-folders">
                            <div class="folder" v-for="folder in folders_selection.items" :key='folder.id' tabindex="0">
                                <span role="button" @click="onFoldersModalOpen()">{{folder.name}}</span>
                                <span class="close" role="button" @click="onFoldersRemove(folder)"></span>
                            </div>
                            <ActionButton icon='fas fa-folder' @click="onFoldersModalOpen()" text='messages.list.search.pick_folder'/>
                        </div>
                    </fieldset>

                    <fieldset class="split-group">
                        <div class="control-group column-100">
                            <div class="control">
                                <label for="subjectField">{{Language.say('messages.list.search.subject')}}</label>
                                <input v-model="full_search.subject" type="text" id="subjectField">
                            </div>
                        </div>
                        <div class="control-group column-50">
                            <div class="control">
                                <label for="fromField">{{Language.say('messages.list.search.from')}}</label>
                                <input v-model="full_search.from" id="fromField" type="text">
                            </div>
                        </div>
                        <div class="control-group column-50">
                            <div class="control">
                                <label for="toField">{{Language.say('messages.list.search.to')}}</label>
                                <input v-model="full_search.to" type="text" id="toField">
                            </div>
                        </div>
                        <div class="control-group column-50">
                            <div class="control">
                                <label for="sBody">{{Language.say('messages.list.search.include_words')}}</label>
                                <input v-model="full_search.body_contain" id="sBody" type="text">
                            </div>
                        </div>
                        <div class="control-group column-50">
                            <div class="control">
                                <label for="sNotBody">{{Language.say('messages.list.search.exclude_words')}}</label>
                                <input v-model="full_search.body_exclude" id="sNotBody" type="text">
                            </div>
                        </div>

                        <div class="control-group column-100">
                            <div class="control">
                                <label for="sDate1">{{Language.say('messages.list.search.between_dates')}}</label>
                                <span class="column-group">
                                    <input v-model="full_search.filter_date_start" id="sDate1" type="date" lang="pt-PT" class="column-50">
                                    <small>{{Language.say('messages.list.search.and')}}</small>
                                    <input v-model="full_search.filter_date_end" id="sDate2" type="date" lang="pt-PT" class="column-50">
                                </span>
                            </div>
                        </div>

                        <div class="control-group column-100 option-size">
                            <div class="control">
                                <label for="sSizeOp">{{Language.say('messages.list.search.size')}}</label>
                                <span class="column-group">
                                    <span class="select-wrapper column-50">
                                        <select v-model="full_search.filter_size_type" id="from">
                                            <option :value="undefined"        :selected="full_search.filter_size_type === undefined">{{Language.say('messages.list.search.any_size')}}</option>
                                            <option value="size_larger"  :selected="full_search.filter_size_type === 'size_large'">{{Language.say('messages.list.search.bigger')}}</option>
                                            <option value="size_smaller" :selected="full_search.filter_size_type === 'size_smaller'">{{Language.say('messages.list.search.smaller')}}</option>
                                        </select>
                                    </span>
                                    <small>{{Language.say('messages.list.search.size_to')}}</small>
                                    <input v-model="full_search.filter_size_value" id="sSizeValue" type="number" class="column-50">
                                    <small>{{Language.say('messages.list.search.kb')}}</small>
                                </span>
                            </div>
                        </div>

                    </fieldset>


                    <fieldset>
                        <legend>{{Language.say('messages.list.search.message')}}</legend>

                        <div class="control-group max-size">
                            <ul class="control radio-buttons-group">
                                <li><span><i class="fas fa-envelope"></i></span></li>
                                <li>
                                    <input v-model="full_search.flag_read" type="radio" :value="true" name="sReadStatus" id="seen" :checked="full_search.flag_read === true" tabindex="-1">
                                    <label for="seen" tabindex="0">{{Language.say('messages.list.search.read')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.flag_read" type="radio" :value="false" name="sReadStatus" id="unseen" :checked="full_search.flag_read === false" tabindex="-1">
                                    <label for="unseen" tabindex="0">{{Language.say('messages.list.search.unread')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.flag_read" type="radio" :value="undefined" name="sReadStatus" id="seenAll" :checked="full_search.flag_read === undefined" tabindex="-1">
                                    <label for="seenAll" tabindex="0">{{Language.say('messages.list.search.all_fem')}}</label>
                                </li>
                            </ul>
                        </div>

                        <div class="control-group max-size">
                            <ul class="control radio-buttons-group">
                                <li><span><i class="far fa-bookmark"></i></span></li>
                                <li>
                                    <input v-model="full_search.flag_flagged" :value="false" type="radio" name="sFlaggedSel" id="flagged" :checked="full_search.flag_flagged === false" tabindex="-1">
                                    <label for="flagged" tabindex="0">{{Language.say('messages.list.search.flagged')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.flag_flagged" :value="true" type="radio" name="sFlaggedSel" id="unflagged" :checked="full_search.flag_flagged === true" tabindex="-1">
                                    <label for="unflagged" tabindex="0">{{Language.say('messages.list.search.unflagged')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.flag_flagged" :value="undefined" type="radio" name="sFlaggedSel" id="flaggedAll" :checked="full_search.flag_flagged === undefined" tabindex="-1">
                                    <label for="flaggedAll" tabindex="0">{{Language.say('messages.list.search.all_fem')}}</label>
                                </li>
                            </ul>
                        </div>

                        <div class="control-group max-size">
                            <ul class="control radio-buttons-group">
                                <li><span><i class="fas fa-paperclip"></i></span></li>
                                <li>
                                    <input v-model="full_search.filter_attachments" :value="0" type="radio" name="sAttach" id="hasAttach" :checked="full_search.filter_attachments === 0" tabindex="-1">
                                    <label for="hasAttach" tabindex="0">{{Language.say('messages.list.search.with_attach')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.filter_attachments" :value="1" type="radio" name="sAttach" id="noAttach" :checked="full_search.filter_attachments === 1" tabindex="-1">
                                    <label for="noAttach" tabindex="0">{{Language.say('messages.list.search.without_attach')}}</label>
                                </li>
                                <li>
                                    <input v-model="full_search.filter_attachments" :value="undefined" type="radio" name="sAttach" id="attachAll" :checked="full_search.filter_attachments === undefined" tabindex="-1">
                                    <label for="attachAll" tabindex="0">{{Language.say('messages.list.search.all_fem')}}</label>
                                </li>
                            </ul>
                        </div>
                    </fieldset>

                </div>

                <div class="search-actions">
                    <ActionButton
                      @click="onFullSearchBack()"
                      class='push-left outline'
                      text='global.actions.back'
                      icon="fas fa-chevron-left"
                    />

                    <button
                      @click.prevent="onFullSearchSubmit()"
                      class="push-right main-action"
                      type="submit"
                    >
                        <i class="fas fa-search"></i>
                        <span>{{Language.say('messages.list.search.search')}}</span>
                    </button>

                    <ActionButton
                      @click="onFullSearchReset()"
                      class='push-right outline'
                      text='messages.list.search.clear'
                    />
                </div>

            </div>

        </form>
    </div>

    <FoldersSelectAllModal v-if="folders_modal_visible"
      @foldersSelectCancel="onFoldersSelectCancel()"
      @foldersSelectSubmit="onFoldersSelectSubmit()"
      :folders_selection_collection='folders_selection_temp'
      button_text="global.actions.confirm"
    />
</template>

<script setup>
  import {ref, reactive}              from "vue";
  import {defineProps, defineEmits}   from "vue";
  import {onBeforeMount, onUnmounted} from "vue";
  import {useRoute}                   from "vue-router";
  import FoldersSelectAllModal        from '@/vue/Views/Folders/Modals/FoldersSelectAllModal.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import MessagesQuickSearch          from '@/js/Mailboxes/Entities/Messages/MessagesQuickSearch.js';
  import MessagesFullSearch           from '@/js/Mailboxes/Entities/Messages/MessagesFullSearch.js';
  import KeyboardController           from '@/js/Webmail/Keyboard/KeyboardController';
  import Language                     from '@/js/Shared/Language/Language.js';
  import CollectionList               from "@/js/Shared/Collections/CollectionList";
  import SAPOMailConfig               from "@/SAPOMailConfig";
  import GTMAnalyticsController       from "@/js/Webmail/Analytics/GTMAnalyticsController";

  const props = defineProps({
    messages_view      : {},
    webmail_view       : {},
    folder_id          : {},
    viewport_controller: {},
  })

  const emit = defineEmits([
    'messagesSearchClose',
  ])

  const route                  = useRoute();
  const full_search_visible    = ref(false);
  const folders_modal_visible  = ref(false);
  const quick_search           = ref();
  const full_search            = ref();
  const quick_search_route     = '/messages/' + SAPOMailConfig.client.folders.alias.search;
  const folders_selection      = reactive(new CollectionList('id'));
  const folders_selection_temp = reactive(new CollectionList('id'));

  onBeforeMount(() => {
    KeyboardController.disableAll();
    setFullSearch();
    setQuickSearch();

    if (route.query.qs === 'quicksearch') {
      quick_search.value.setFromQueryString(quick_search.value, route.query);
    }

    if (route.query.qs === 'fullsearch') {
      full_search.value.setFromQueryString(route.query);
      setInitialSelectedFolders();
      setFullSearchVisibility(true);
    }
  })

  onUnmounted(() => {
    KeyboardController.enableAll();
  })


  const onSearchClose = () => {
    emit('messagesSearchClose');
  }

  const onQuickSearchClear = () => {
    quick_search.value.qsearch = null;
  }

  const onQuickSearchSubmit = () => {
    GTMAnalyticsController.postTrackerLink('messages', 'messages_quick_search', 'search_form', 'submit');

    if (!quick_search.value.qsearch) {
      return;
    }

    props.webmail_view.routeTo(quick_search_route, quick_search.value);
  }

  const onFullSearchBack = () => {
    folders_selection.reset();
    setFullSearchVisibility(false);
  }

  const onFullSearchShow = () => {
    setInitialSelectedFolders();
    setFullSearchVisibility(true);
  }

  const onFoldersModalOpen = () => {
    folders_selection_temp.reset();
    folders_selection_temp.addItems(folders_selection.index);
    setFoldersModalVisibility(true);
  }

  const onFoldersSelectSubmit = () => {
    folders_selection.reset();
    folders_selection.addItems(folders_selection_temp.index);
    setFoldersModalVisibility(false);
  }

  const onFoldersSelectCancel = () => {
    setFoldersModalVisibility(false);
  }

  const onFullSearchReset = () => {
    setFullSearch();
  }

  const onFullSearchSubmit = async () => {
    GTMAnalyticsController.postTrackerLink('messages', 'messages_full_search', 'search_form', 'submit');

    let search = await props.viewport_controller.fetchMessagesFullSearchCriteria(
      full_search.value,
      folders_selection.getIndexKeys()
    );

    if (search.folder_id) {
      props.webmail_view.routeTo('/messages/' + search.folder_id, search.criteria);
    }
  }

  const onFoldersRemove = (folder) => {
    folders_selection.delete(folder.id);

    if (folders_selection.count === 0) {
      setSelectedInbox();
    }
  }

  const setFullSearchVisibility = (value) => {
    full_search_visible.value = value;
  }

  const setFoldersModalVisibility = (value) => {
    folders_modal_visible.value = value;
  }

  const setInitialSelectedFolders = () => {
    if (!route.query.mboxes && folders_selection.count === 0) {
      setSelectedInbox();
      return;
    }

    setSelectedMboxes();
  }

  const setSelectedInbox = () => {
    folders_selection.add(
      props.viewport_controller.mailboxes.folders.all.get(props.folder_id)
    );
  }

  const setSelectedMboxes = () => {
    let folders = route.query.mboxes.split(':');

    folders.forEach((folder_id) => {
      if (props.viewport_controller.mailboxes.folders.all.exists(folder_id) === false) {
        return;
      }

      folders_selection.add(
        props.viewport_controller.mailboxes.folders.all.get(folder_id)
      );
    })
  }

  const setFullSearch = () => {
    full_search.value             = new MessagesFullSearch();
    full_search.value.qsearchmbox = route.query.qsearchmbox || props.folder_id;
  }

  const setQuickSearch = () => {
    quick_search.value             = new MessagesQuickSearch();
    quick_search.value.qsearchmbox = route.query.qsearchmbox || props.folder_id;
  }
</script>
